import { NOTIFICATION_HANDLER } from '@Constants/types';
import store from '../store';

export function dismissError() {
    store.dispatch({ type: NOTIFICATION_HANDLER.DISMISS_ERROR });
}
